import { createFileRoute } from '@tanstack/react-router'

import CheckoutPage from '@/views/checkout/checkout.page'

export const Route = createFileRoute('/_layout/checkout')({
  component: CheckoutPage,
})
